import Vue from 'vue'
import VueTippy, { TippyComponent } from 'vue-tippy'
import 'tippy.js/themes/light.css'

Vue.use(VueTippy, {
  directive: 'tippy', // => v-tippy
  flipDuration: 0,
  //   popperOptions: {
  //     modifiers: {
  //       preventOverflow: {
  //         enabled: false,
  //       },
  //       hide: { enabled: false },
  //     },
  //   },
})

Vue.component('Tippy', TippyComponent)
